/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/uikit/uikit.d.ts" />
/// <reference path="../../customtypings/ion-range-slider/ion-range-slider.d.ts" />

namespace Application.Controllers {
    'use strict';

    import Utils = Common.Utils;

    interface ICustomizedTimelineItem extends Vis.ITimelineItem {
        data?: Models.TissRecordingNode;
        serverHref?: string;
        clientHref?: string;
        serverIpAddress?: string;
    }

    /**
     * RecordingsExportsController class
     */
    export class RecordingsExportsController {

        public static $name: string = "recordingsExportsController";
        public static $inject: string[] = ['$scope', 
                                           'recordingsExportsService',  
                                           'networkNodeService',
                                           'ModalService',
                                           '$timeout',
                                           '$interval',
                                           'timezoneService',
                                           'messageTranslationsService'];

        private static RELOAD_INTERVAL: number = 5000;

        private allRecordingsExports: Models.AllRecordingsExports;
        private leadIn: number;
        private leadOut: number;

        private videoPlayerModal: ngModal.IModalObject;
        private serverExports: Models.TissExportNode[];
        private deletedServerExports: Models.TissExportNode[];
        private clientExports: Models.ClientExportNode[];
        private runningTasks: Models.RunningTask[];

        private optionsTimeline: Vis.ITimelineOptions;

        private visTimeline: Vis.ITimeline;
        private visItems: Vis.ITimelineItem[];
        private visGroups: Vis.ITimelineGroup[];
        private visItemId: number;
        private visGroupId: number;
        private selectedItem: ICustomizedTimelineItem;
        private exportDescription: string;

        private streamURL: string;
        private autoplay: boolean;

        private reload: ng.IPromise<{}>;

        /**
         * Constructor
         */
        constructor(private $scope: ng.IScope,
                    private recordingsExportsService: Services.RecordingsExportsService,
                    private networkNodeService: Services.NetworkNodeService,
                    private modalService: ngModal.IModalService,
                    private $timeout: ng.ITimeoutService,
                    private $interval: ng.IIntervalService,
                    private timezoneService: Services.TimezoneService,
                    private messageTranslationsService: Services.MessageTranslationsService ) {
            $timeout(() => {
                window.altair_admin_common_init();
            }, 500);
            this.init();
        }

        public transcodeServerExport(serverExport: Models.TissExportNode, index: number): void {
            this.recordingsExportsService.transcodeServerExport(serverExport.serverHref, serverExport.resource,
                $('#select_server_tc_' + index).val(), serverExport.exportfile)
                .then(() => {
                    Common.Utils.alertOnSuccess("Transcoding requested");

                    for (let i: number = 0; i < this.serverExports.length; i++) {
                        if (this.serverExports[i].equals(serverExport)) {
                            this.serverExports[i].transcode.status = "running";
                            this.serverExports[i].transcode.progress = "%";
                            break;
                        }
                    }
                })
                .catch(() => {
                    Common.Utils.alertOnSuccess("Error on transcoding request. Please, try again later.");
                });
        }

        public transcodeClientExport(clientExport: Models.ClientExportNode, index: number): void {
            this.recordingsExportsService.transcodeClientExport(clientExport.serverHref, clientExport.sessionid,
                clientExport.start, clientExport.end, clientExport.resource, $('#select_client_tc_' + index).val(),
                clientExport.exportfile);
        }

        public deleteServerExport(serverExport: Models.TissExportNode): void {
            this.recordingsExportsService.deleteServerExport(serverExport.serverHref, serverExport.start,
                serverExport.end, serverExport.resource, serverExport.description)
                .then(() => {
                    Common.Utils.alertOnSuccess("Export deleted");
                    
                    for (let i: number = 0; i < this.serverExports.length; i++) {
                        if (this.serverExports[i].equals(serverExport)) {
                            this.deletedServerExports.push(this.serverExports[i]);
                            this.serverExports.splice(i, 1);
                            break;
                        }
                    }
                })
                .catch(() => {
                    this.messageTranslationsService.alertOnError("Could not delete export. Please, try again later.");
                });
        }

        public deleteClientExport(clientExport: Models.ClientExportNode): void {
            this.recordingsExportsService.deleteClientExport(clientExport.serverHref, clientExport.sessionid,
                clientExport.start, clientExport.end, clientExport.resource, clientExport.description);
        }

        /**
         * Launch a modal when attempting to delete a export from the list
         */
        public deleteServerExportModal(serverExport: Models.TissExportNode): void {
            let self: RecordingsExportsController = this;
            this.modalService.showModal({
                templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                controller: Application.Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'DELETE EXPORT',
                    description: "This action cannot be undone.",
                    name: serverExport.description,
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                    if (result)
                        self.deleteServerExport(serverExport);
                });
            });
        }

        /**
         * Launch a modal when attempting to delete a export from the list
         */
        public deleteClientExportModal(clientExport: Models.ClientExportNode): void {
            let self: RecordingsExportsController = this;
            this.modalService.showModal({
                templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                controller: Application.Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'DELETE EXPORT',
                    description: "This action cannot be undone.",
                    name: clientExport.description,
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                    if (result)
                        self.deleteClientExport(clientExport);
                });
            });
        }

        public createExport(): void {
            this.recordingsExportsService.createServerExport(this.selectedItem.serverHref, this.selectedItem.data.resource,
                this.selectedItem.data.start + this.leadIn, "MP4", this.selectedItem.data.start + this.leadOut, this.exportDescription)
                .then(() => {
                    Common.Utils.alertOnSuccess("Export creation queued");
                    this.exportDescription = "";
                })
                .catch(() => {
                    this.messageTranslationsService.alertOnError("Could not create export. Please, try again later.");
                });
        }

        public showVideo(url: string): void {
            this.modalService
                .showModal({
                    templateUrl: Application.Controllers.VideoPlayerModalController.templateUrl,
                    controller: Application.Controllers.VideoPlayerModalController.$name,
                    inputs: {
                        streamURL: url,
                        live: false,
                        blockId: undefined,
                        videoFeed: undefined,
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let videoPlayerModalElem: UIkit.ModalElement;
                    videoPlayerModalElem = UIkit.modal(Application.Controllers.VideoPlayerModalController.ID,
                                                        {bgclose: false, modal: false, keyboard: false});
                    videoPlayerModalElem.show();
                    this.videoPlayerModal = modal;
                    modal.close.then(() => {
                        videoPlayerModalElem.hide();
                        this.videoPlayerModal = undefined;
                    });
            });
        }

        public uploadTTF(resource: string, file: string): void {
            this.modalService
                .showModal({
                    templateUrl: Application.Controllers.TTFUploadModalController.templateURL,
                    controller: Application.Controllers.TTFUploadModalController.$name,
                    inputs: {
                        resource: resource,
                        file: 'http://' + file,
                    },
                })
                .then((modal: ngModal.IModalObject) => {
                    let ttfUploadModalElem: UIkit.ModalElement;
                    ttfUploadModalElem = UIkit.modal(Application.Controllers.TTFUploadModalController.ID,
                                                     {bgclose: false, modal: false, keyboard: false});
                    ttfUploadModalElem.show();
                    modal.close.then(() => {
                        ttfUploadModalElem.hide();
                    });
            });
        }

        private generateExports(client: Models.IRecordingsExports): void {
            if (client.recordingsExportsData.length > 0) {
                for (let i: number = 0; i < client.recordingsExportsData.length; i++) {
                    let recordingsExportsServer: Models.RecordingsExportsData = client.recordingsExportsData[i];
                    
                    for (let j: number = 0; j < recordingsExportsServer.recordingsExports.tissExports.length; j++) {
                        let serverExport: Models.TissExportNode = recordingsExportsServer.recordingsExports.tissExports[j];

                        let newServerExport: Models.TissExportNode = Models.TissExportNode.addFrontData(serverExport,
                            client.clientHref, recordingsExportsServer.serverHref, recordingsExportsServer.serverIpAddress);

                        // checks if the export was already removed,
                        // as it takes some time until the backend is updated
                        // yeah, this is ugly
                        let found: boolean = false;
                        for (let exp of this.deletedServerExports) {
                            if (exp.equals(newServerExport)) {
                                found = true;
                                break;
                            }
                        }

                        if (!found)
                            this.serverExports.push(newServerExport);
                    }

                    for (let k: number = 0; k < recordingsExportsServer.recordingsExports.clientExports.length; k++) {
                        let clientExport: Models.ClientExportNode = recordingsExportsServer.recordingsExports.clientExports[k];

                        let newClientExport: Models.ClientExportNode = Models.ClientExportNode.addFrontData(clientExport,
                            client.clientHref, recordingsExportsServer.serverHref, recordingsExportsServer.serverIpAddress);
                        
                        this.clientExports.push(newClientExport);
                    }
                }
            }
        }

        private createVisGroup(content: string): Vis.ITimelineGroup {
            return {
                id: this.visGroupId++,
                content: content,
            };
        }

        private getVisItemData(id: number): ICustomizedTimelineItem {
            for (let i: number = 0; i < this.visItems.length ; i++) {
                if (this.visItems[i].id === id) {
                    return this.visItems[i];
                }
            }
        }

        private createVisItem(type: Models.ExportType, content: string, group: number, 
                              data: Models.TissRecordingNode, serverHref: string,
                              clientHref: string, serverIpAddress: string): ICustomizedTimelineItem {
            let initDate: string = Common.Utils.epochToHHMMSS(data.start);
            let endDate: string = Common.Utils.epochToHHMMSS(data.end);
            return {
                id: this.visItemId++,
                content: '<div><i class="material-icons md-24" style="color: var(--flex-dark-blue);">&#xE02C;</i>'
                         + initDate + ' - ' + endDate + '</div>',
                group: group,
                start: Utils.epochSecondsToMilliseconds(data.start),
                end: Utils.epochSecondsToMilliseconds(data.end),
                serverHref: serverHref,
                clientHref: clientHref,
                serverIpAddress: serverIpAddress,
                data: data,
                editable: false, 
            };
            
        }

        private updateSlider(max: number): void {
            this.leadIn = 0;
            this.leadOut = max;
            let slider: Ion.RangeSlider = $("#ionslider").data("ionRangeSlider");
            if (slider) {
                // slider already exists, then updates
                slider.update({
                    min: 0,
                    from: 0,
                    max:  max,
                    to: max,
                });
            }else {
                // initialize slider
                $("#ionslider").ionRangeSlider({
                    type: "double",
                    min: 0,
                    max: max,
                    from: 0,
                    to: max,
                    step: 1,
                    prettify: (value: number): string  => {
                        return Utils.secsToHHMMSS(value);
                    },
                    onChange: (data: Ion.RangeSliderData): void => {
                        this.leadIn = data.from;
                        this.leadOut = data.to;
                    },
                    onFinish: (data: Ion.RangeSliderData): void => {
                        this.autoplay = true;
                        this.setStreamURL();
                    },
                });
            }
        }

        private setStreamURL(): void {
            // most of the streams fail to load at random positions, should be fixed by MVP
            // let playPathWithPosition: string = this.getStreamUrlWithStartPosition();
            let playPathWithPosition: string = this.selectedItem.data.playPath;
            this.streamURL = 'rtmp://' + this.selectedItem.serverIpAddress + '/live' + 
                             playPathWithPosition;
        }

        /* tslint:disable */
        private getStreamUrlWithStartPosition(): string {
            if (this.leadIn === undefined || this.selectedItem.data.playPath.indexOf('=') === -1) {
                return this.selectedItem.data.playPath; 
            } else {
                try {
                    // reads the original start position and adds the current lead in from the slider
                    let newPlayPath: string = "";
                    let split: string[] = this.selectedItem.data.playPath.split('=');
                    split[split.length - 1] = (parseInt(split[split.length - 1]) + this.leadIn).toString();
                    for (let str of split) {
                        if (newPlayPath === "")
                            newPlayPath += str;
                        else
                            newPlayPath += "=" + str;
                    }
                    return newPlayPath;
                } catch (e) {
                    console.error(e);
                    return this.selectedItem.data.playPath; 
                } 
            }
        }
        /* tslint:enable */

        private loadTimeline(): void {
            let items: vis.DataSet = new vis.DataSet(this.visItems);
            let groups: vis.DataSet = new vis.DataSet(this.visGroups);
            this.visTimeline = new vis.Timeline(document.getElementById('mytimeline'), items, groups, this.optionsTimeline);
            this.visTimeline.on('select', (properties: Vis.IVisSelectProperties) => {
                let selectedId: number = properties.items[0];
                if (selectedId !== undefined) {
                    // check if it has have selected the same item
                    if (!this.selectedItem || this.selectedItem.id !== selectedId) {
                        // launch a digest cycle
                        this.$timeout(() => {
                            this.exportDescription = "";
                            this.selectedItem = this.getVisItemData(selectedId);
                            this.setStreamURL();
                            let ionRangeMax: number = this.selectedItem.data.end - this.selectedItem.data.start;
                            this.updateSlider(ionRangeMax);
                            // this.visTimeline.setWindow(this.selectedItem.start, this.selectedItem.end);
                        });
                    }
                } else {
                    // clicked outside
                    this.$timeout(() => {
                        this.selectedItem = undefined;
                        this.exportDescription = "";
                    });
                }
            });
        }

        private generateData(loadTimeline: boolean): void {
            this.serverExports = [];
            this.clientExports = [];
            if (loadTimeline)
                this.initializeVisElements();
            // 'requests' manage all for loop iterations has been completed
            let requests: number = 0;
            let min: number = Utils.MAX_INTEGER;
            let max: number = 0;
            // iterate over clients
            for (let i: number = 0; i < this.allRecordingsExports.allRecordingsExports.length; i++) {
                let client: Models.IRecordingsExports = this.allRecordingsExports.allRecordingsExports[i];
                this.generateExports(client);
                requests++;
                if (loadTimeline) {
                    this.networkNodeService.getByIdString(client.clientHref,
                        (networkNode: Models.NetworkNode) => {
                            let newGroup: Vis.ITimelineGroup = this.createVisGroup(networkNode.name);
                            this.visGroups.push(newGroup);
                            requests--;
                            // iterate over servers
                            for (let j: number = 0; j < client.recordingsExportsData.length; j++) {
                                let recordingsExportsServer: Models.RecordingsExportsData = client.recordingsExportsData[j]; 
                                // iterate over server recordings
                                let recordingExports: Models.EmbedRecordingExports = client.recordingsExportsData[j].recordingsExports;
                                let offset: number = this.timezoneService.getEffectiveOffsetSeconds();
                                for (let k: number = 0; k < recordingExports.tissRecordings.length; k++) {
                                    // insert server recording with all necessary data
                                    recordingExports.tissRecordings[k].start += offset;
                                    recordingExports.tissRecordings[k].end += offset;
                                    if (recordingExports.tissRecordings[k].start < min) min = recordingExports.tissRecordings[k].start;
                                    if (recordingExports.tissRecordings[k].end > max) max = recordingExports.tissRecordings[k].end;
                                    this.visItems.push(this.createVisItem(Models.ExportType.Server, networkNode.name, newGroup.id,
                                        recordingExports.tissRecordings[k], recordingsExportsServer.serverHref,
                                        undefined, recordingsExportsServer.serverIpAddress));
                                }
                            }
                            if (requests === 0) {
                                let minDate: Date = new Date(0);
                                let maxDate: Date = new Date(0);
                                this.optionsTimeline.min = minDate.setUTCSeconds(min);
                                this.optionsTimeline.max = maxDate.setUTCSeconds(max);
                                if (loadTimeline)
                                    this.loadTimeline();
                                // else
                                //     this.visTimeline.setItems(this.visItems);
                            }
                        }
                    );

                }
            }
        }

        private getRecordingsExports(init: boolean): void {
            this.recordingsExportsService.getAllRecordingsExports(init)
                .then((allRecordingsExports: Models.AllRecordingsExports) => {
                    this.allRecordingsExports = allRecordingsExports;
                    this.generateData(init);

                    this.recordingsExportsService.getRunningTasks(init)
                        .then((runningTasks: Models.RunningTask[]) => {
                            this.runningTasks = runningTasks;
                        });
                });
        }

        private initializeVisElements(): void {
            this.visItemId = 0;
            this.visGroupId = 0;

            this.visGroups = [];
            this.visItems = [];

            this.optionsTimeline = {
                stack: false,
                orientation: 'top',
            };
        }

        private init(): void {
            this.exportDescription = "";
            this.selectedItem = undefined;
            this.deletedServerExports = [];
            this.getRecordingsExports(true);

            this.reload = this.$interval(() => {
                this.getRecordingsExports(false);
            }, RecordingsExportsController.RELOAD_INTERVAL);

            this.$scope.$on('$destroy', () => {
                if (this.reload) {
                    this.$interval.cancel(this.reload);
                }

                if (this.visTimeline) {
                    this.visTimeline.destroy();
                    this.visTimeline = undefined;
                }
            });
        }
    }
}
